<template>
  <div class="message">
    <div class="conversation" ref="box">
      <div v-show="showEmpty" class="empty">
        <p v-if="conversationID">暂时没有新消息</p>
        <p v-else>未选择聊天</p>
      </div>
      <ul>
        <kt-bubble v-for="message in list" :key="message.msg_id"
        :message="message"></kt-bubble>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters,mapActions} from 'vuex';
  import ktBubble from './bubble'
  export default {
    data () {
      return {

      }
    },
    watch: {
      messages() {
        this.$nextTick(() => {
          let container = this.$refs.box;
          container.scrollTop = container.scrollHeight;
        })
      }
    },
    methods:{
      loadHistoryMessages() {

        let param = {
          conversation_id: conversation_id,
          num: 0,
          size: 10
        };
        this.findMessages(param);
      },
      ...mapActions([
        'findMessages'
      ])
    },
    computed:{
    	showEmpty() {
    		return !this.messages.length;
      },
      list() {
        this.messages.forEach(function(value,index,array){
          if (!value.showTime) {
          	if (index === 0) {
          		value.showTime = true;
            }else {
          		let item = array[index-1];
          		let space = (value.sendtime - item.sendtime)/1000;
          		if (space/60 > 1) {
                value.showTime = true;
              }else {
                value.showTime = false;
              }
            }
          }
        });
        return this.messages;
      },
      ...mapState({
        conversationID:state=>state.conversation.conversationID,
      }),
      ...mapGetters({
        messages: 'chat_messages',
      })
    },
    components: {
      ktBubble
    }
  }
</script>

<style lang="scss" scoped>
  .message {
    flex: 1;
    .conversation {
      padding: 10px 15px;
      overflow-y: auto;
      min-height: 450px;
      max-height: 450px;
      box-sizing: border-box;
      .empty {
        text-align: center;
        margin-top: 130px;
        color: #ccc;
        font-size: 13px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/chat/components/content.vue